import Marquee from "react-fast-marquee";

const ITEMS = [
  "10 MW Captive Microgrid Enclosures",
  "100% Zero-Fault Connectivity Guarantee",
  "Ground-to-Space Satellite Shield",
  "Secure System Node: Active",
  "Executive Order 14373 Compliant",
  "U.S. Trustee Escrow Routing",
];

export const EditorialMarquee = () => {
  return (
    <div data-testid="editorial-marquee" className="border-b border-zinc-800 py-6 overflow-hidden">
      <Marquee speed={26} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span
            key={item}
            className="mx-8 text-xs sm:text-sm tracking-[0.3em] uppercase text-zinc-500 whitespace-nowrap"
          >
            {item} <span className="text-zinc-700 ml-16">///</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
